import type { FormatConverterProps } from './FormatConverters.types';

export const formatFromNumberToMoney = ({
  value,
  options = {
    maximumFractionDigits: 0,
  },
}: FormatConverterProps): string =>
  Number(value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    ...options,
  });
export const formatFromMoneyToNumber = ({ value }: FormatConverterProps): number =>
  Number(String(value).replace(/[$,]/g, ''));
export const addDecimals = ({ value, options = {} }: FormatConverterProps) => {
  const parsedValue = String(value).replace(/[$,]/g, '');
  return parsedValue.endsWith('.')
    ? parsedValue
    : Number(parsedValue).toLocaleString('en-US', options);
};
